import { render, staticRenderFns } from "./announcement_type.vue?vue&type=template&id=2161bd26&scoped=true&"
import script from "./announcement_type.vue?vue&type=script&lang=js&"
export * from "./announcement_type.vue?vue&type=script&lang=js&"
import style0 from "./announcement_type.vue?vue&type=style&index=0&id=2161bd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2161bd26",
  null
  
)

export default component.exports